"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLink = exports.LinkProvider = exports.LinkContext = void 0;
const react_1 = require("react");
const LinkContext = (0, react_1.createContext)(undefined);
exports.LinkContext = LinkContext;
const LinkProvider = LinkContext.Provider;
exports.LinkProvider = LinkProvider;
const useLink = () => {
    const context = (0, react_1.useContext)(LinkContext);
    if (typeof window !== "undefined") {
        if (context === undefined) {
            throw new Error("This component is a LinkConsumer, it must be used within a LinkProvider. Use this within a parent Link component.");
        }
        return context;
    }
    return Object.assign({ theme: "light", openInNewTab: false }, context);
};
exports.useLink = useLink;
//# sourceMappingURL=Link.context.js.map